import { withLifeErrorBoundary } from '@festina-life/components'
import { useMemo } from 'react'

import { useTemplateContext } from '../../context/templateContext'
import type { TemplateReferenceNode } from '../../types/templateModel'
import { buildReferenceHierarchy } from './plottingHelpers'
import { SubTemplateDiagram } from './SubTemplateDiagram'
import { SubTemplateDiagramActions } from './SubTemplateDiagramActions'

type Props = {
  /** Root reference type to render. */
  templateReferenceNode: TemplateReferenceNode
}

const SubTemplateControllableDiagramInternal = ({
  templateReferenceNode,
}: Props) => {
  const { referencedVersions } = useTemplateContext()

  const d3Hierarchies = useMemo(
    () => buildReferenceHierarchy(templateReferenceNode, referencedVersions),
    [referencedVersions, templateReferenceNode],
  )

  return (
    <div>
      <div className="relative mt-4">
        <SubTemplateDiagramActions
          className="absolute right-2 -top-2 rounded-md p-2 text-primary opacity-90"
          d3Hierarchies={d3Hierarchies}
        />
        <div className="overflow-auto">
          {d3Hierarchies.map((d3Hierarchy) => (
            <SubTemplateDiagram
              key={d3Hierarchy.data.id}
              d3Hierarchy={d3Hierarchy}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export const SubTemplateControllableDiagram = withLifeErrorBoundary(
  SubTemplateControllableDiagramInternal,
)
